import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useUpdateAlert } from "./useUpdateAlert"
import {
  useDebouncedUpdater,
  useShowGenericErrorToast,
} from "src/hooks/forms"

export function useDebouncedUpdateAlert(
  primaryPhone: Phone | undefined,
  sugarmateAlert: Alert | undefined,
  errorToastId: string,
) {
  const onError = useShowGenericErrorToast(errorToastId)

  const updateAlert = useUpdateAlert(
    primaryPhone,
    sugarmateAlert,
  )

  const debouncedUpdateAlert = useDebouncedUpdater({
    updater: updateAlert,
    onError,
  })

  return useCallback(
    (partialSugarmateAlert: Partial<Alert>) => {
      if (!sugarmateAlert) {
        onError()
        return
      }

      debouncedUpdateAlert({
        ...partialSugarmateAlert,
      })
    },
    [
      debouncedUpdateAlert,
      sugarmateAlert,
      onError,
    ],
  )
}
